export const DETAIL_DIALOG_FORM_FIELD_WIDTH_PX = 144;
export const WIDE_DETAIL_DIALOG_FORM_FIELD_WIDTH_PX = 144;
